
import { Action              } from "@/models/action";
import { ActionType          } from "@/models/action.type";

import { LeafletViewer } from "@/components/leaflet/leaflet.viewer";

export class OverviewNavigateById extends Action {

  /** the panorama to navigate to */
  public _id: number = 0;

  /** to overwatch controller that can actually do stuff for us */
  private readonly _controller : LeafletViewer = null;

  /** standard constructor */
  constructor(controller : LeafletViewer) {
    super({
      key:   ActionType.OVERWATCH_NAVIGATE_BY_ID,
      type:  ActionType.OVERWATCH_NAVIGATE_BY_ID,
      label: 'Navigate to Panorama by id',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** set the turn amount (degrees) */
  public to(id: number) {

    this._id = id;
  }

  /** fetch the turn amount (delta) */
  public id(): number {

    return this._id;
  }

  /** fetch the panoramic controller */
  public controller(): LeafletViewer {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    if (this._id < 1) {

      if (this.args.length > 0) {

        this._id = Number(this.args[0]);
      }
    }

    this._controller.navigateTo(this._id);

    return true;
  }

  public static from(a: OverviewNavigateById) {

    return new OverviewNavigateById(a.controller());
  }
}
